<template>
  <component
    :is="tag"
    :class="classes"
    class="button"
    :type="type"
    :disabled="disabled"
    :href="href"
    @click="handleClick"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: "CustomButton",
  props: {
    theme: {
      type: String,
      default: "primary",
      validator(value) {
        return ["primary", "secondary", "outline", "white"].includes(value);
      },
    },
    type: {
      type: String,
      default: "button",
      validator(value) {
        return ["button", "submit"].includes(value);
      },
    },
    tag: {
      type: String,
      default: "button",
      validator(value) {
        return ["a", "button"].includes(value);
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large"].includes(value);
      },
    },
    easysize: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["click"],
  computed: {
    classes() {
      return {
        "button--small": this.size === "small",
        "button--medium": this.size === "medium",
        "button--large": this.size === "large",
        "button--full-width": this.fullWidth,
        "button--transparent": this.transparent,
        "button--secondary": this.theme === "secondary",
        "button--white": this.theme === "white",
        "button--outline": this.theme === "outline",
        "button--light": this.light,
        easysize_button: this.easysize,
      };
    },
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  background: $color-dark;
  padding: 14px;
  border-radius: 2px;
  outline: none;
  border: none;
  color: $color-white;
  text-transform: uppercase;
  font-size: 9px;
  letter-spacing: 0.49px;
  cursor: pointer;
  font-weight: 600;
  text-align: center;
  text-decoration: none;

  &--small {
    padding: 10px;
  }

  &--secondary {
    background-color: rgba($color-dark, 0.3);
  }

  &--white {
    background-color: $color-white;
    color: $color-dark;
  }

  &--outline {
    background-color: $color-white;
    border: 1px solid $color-dark;
    color: $color-dark;
  }
}

.button--full-width {
  display: block;
  width: 100%;
}

.button--transparent {
  background: transparent;
  padding-left: 0;
  padding-right: 0;
  color: $color-dark;
}

.button--light {
  color: $color-white;
}
</style>
